<template>
    <div>Editor</div>
</template>